import React, { useState } from 'react';
import { Stepper } from 'react-form-stepper';
import PageHeader from "../../components/PageHeader";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import { Button, Form } from "react-bootstrap";
import SearchSelect from '../../components/SearchSelect';
import MultiSelect from '../../components/MultiSelect';
const CreateLeadPage = () => {
    const [activeStep, setActiveStep] = useState(0);

    const stepForm = [
        {
            id: 1,
            component: (
                <StepOne activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 2,
            component: (
                <StepTwo activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        },
        {
            id: 3,
            component: (
                <StepThree activeStep={activeStep} setActiveStep={setActiveStep} />
            ),
        }
        // { id: 4, component: <StepOne activeStep={activeStep} /> },
    ];
    return (
        <>
            <PageHeader name="Create Lead" />
            <div>
                {/* <Stepper
                    steps={[{ label: 'Basic Info' }, { label: 'Business Info' }, { label: 'Others Info' }]}
                    styleConfig={{
                        activeBgColor: "rgba(45, 51, 61, 0.6)",
                        activeTextColor: "#fff",
                        inactiveBgColor: "#fff",
                        inactiveTextColor: "#999",
                        completedBgColor: "rgb(45, 51, 61)",
                        completedTextColor: "#fff",
                        size: "2em",
                    }}
                    activeStep={activeStep+1}
                /> */}
                <div className="row justify-content-center">
                    <div className="col-xl-11">
                        <div className="card custom-card">
                            <div className="card-body">
                                <h5 className="text-start">Create Lead</h5>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name:</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Name" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email:</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Email" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone Number:</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Phone Number" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gender :</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Gender " />
                                        </Form.Group>
                                    </div>
                                    {/* <div className="col-lg-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Addresses:</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Address 1" className="mb-1" />
                                            <Form.Control type="text" placeholder="Enter Address 2" className="mb-1" />
                                            <Form.Control type="text" placeholder="Enter Address 3" className="mb-1" />
                                        </Form.Group>
                                    </div> */}
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Street Address:</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Street Address" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Appt Number:</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Appt Number" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>City:</Form.Label>
                                            <Form.Control type="text" placeholder="Enter City" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>State:</Form.Label>
                                            <Form.Control type="text" placeholder="Enter State" />
                                        </Form.Group>
                                    </div>

                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Zip Code:</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Zip Code" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Metro Area:</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Metro Area" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Assign To:</Form.Label>
                                            {/* <Form.Control type="text" placeholder="Enter Assign To" /> */}
                                            <SearchSelect
                                                options={
                                                    [
                                                        { value: 'User A', label: 'User A' },
                                                        { value: 'User B', label: 'User B' },
                                                        { value: 'User C', label: 'User C' }
                                                    ]
                                                }
                                                placeholder={"Enter Assign User"}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Status:</Form.Label>
                                            {/* <Form.Control type="text" placeholder="Enter Status" /> */}
                                            <SearchSelect
                                                options={
                                                    [
                                                        { value: 'Active', label: 'Active' },
                                                        { value: 'Inactive', label: 'Inactive' },
                                                    ]
                                                }
                                                placeholder={"Enter Status"}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tags:</Form.Label>
                                            <MultiSelect
                                                options={
                                                    [
                                                        { value: 'Tag 1', label: 'Tag 1' },
                                                        { value: 'Tag 2', label: 'Tag 2' },
                                                        { value: 'Tag 3', label: 'Tag 3' },
                                                        { value: 'Tag 4', label: 'Tag 4' },
                                                        { value: 'Tag 5', label: 'Tag 5' },
                                                        { value: 'Tag 6', label: 'Tag 6' },
                                                        { value: 'Tag 7', label: 'Tag 7' },
                                                    ]
                                                }
                                            />
                                        </Form.Group>
                                    </div>
                                    
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Notes:</Form.Label>
                                            <Form.Control as="textarea" placeholder="Enter Notes" />
                                        </Form.Group>
                                    </div>
                                    {/* <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gender:</Form.Label>
                                            <Form.Select>
                                                <option value="">Male</option>
                                                <option value="">Female</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </div> */}
                                    <div className="col-lg-12 d-flex mb-3 gap-3 justify-content-end">
                                        <Button
                                            variant="primary"
                                            className="text-white mt-auto px-5"

                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant="primary"
                                            className="text-white mt-auto px-5"

                                        >
                                            Save
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* {stepForm[activeStep].component} */}
        </>
    );
};

export default CreateLeadPage;